import { Component, input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'ui-loading-icon',
  imports: [CommonModule],
  templateUrl: './loading-icon.component.html',
})
export class LoadingIconComponent {
  readonly loading = input(false);
}
